import { toastr } from 'react-redux-toastr';

import {
  setSectionSaveService,
  checkSectionSaveExistanceService,
} from 'services/sectionSave';
import {
  SAVED_SECTIONS_CREATE_SECTION_SAVE_FAIL,
  SAVED_SECTIONS_CREATE_SECTION_SAVE_INIT,
  SAVED_SECTIONS_CREATE_SECTION_SAVE_SUCCESS,
} from 'state/actionCreators/savedSections';

export const createSectionSave = ({ section, items, sectionIdentifier, sectionDescription }) => {
  return async (dispatch) => {
    dispatch(SAVED_SECTIONS_CREATE_SECTION_SAVE_INIT());

    try {
      const sectionSaveExists = await checkSectionSaveExistanceService({
        sectionIdentifier,
      });

      if (sectionSaveExists) {
        return dispatch(
          SAVED_SECTIONS_CREATE_SECTION_SAVE_FAIL({ error: 'section-exists' })
        );
      }
    } catch (error) {
      toastr.error('Error Saving the Section', error);
      return dispatch(SAVED_SECTIONS_CREATE_SECTION_SAVE_FAIL({ error }));
    }

    try {
      await setSectionSaveService({ section, items, sectionIdentifier, sectionDescription });
    } catch (error) {
      toastr.error('Error Saving the Section', error);
      return dispatch(SAVED_SECTIONS_CREATE_SECTION_SAVE_FAIL({ error }));
    }

    toastr.success('', 'Section successfully Saved.');

    return dispatch(SAVED_SECTIONS_CREATE_SECTION_SAVE_SUCCESS());
  };
};
